import { Backdrop } from './Backdrop.style';

export const BackdropView = () => {
  return <Backdrop aria-hidden="true" />;
};
